<template>
  <div id="root">
    <Layout>
      <router-view />
    </Layout>
  </div>
</template>

<script>
import Layout from "@/layouts/Layout";

export default {
  name: "App",
  components: {
    Layout,
  },
};
</script>
<style>
/* @font-face {
  font-family: "Raleway";
  src: local("Raleway"), url(~assets/font/Raleway-Regular.ttf) format("truetype");
}
@font-face {
  font-family: "Raleway Light";
  src: local("Raleway Light"), url(~assets/font/Raleway-Light.ttf) format("truetype");
} */
/* .v-application {
  font-family: "Raleway";
} */
.font-text-regular {
  font-family: "Raleway";
}
.font-text-light {
  font-family: "Raleway Light";
}
.bg-primary {
  background-color: #027881;
}
.text-primary {
  color: #027881;
}
.bg-secondary {
  background-color: #fdee5f;
}
.text-secondary {
  color: #fdee5f;
}
/* border drawer */
/* .v-navigation-drawer .v-navigation-drawer__border {
  background-color: transparent !important;
} */
/* select filters imputs */
.select-filters .v-text-field__details {
  display: none !important;
}
.imput-icon .v-input__icon--append i {
  font-size: 16px;
}

/* shadows */
.v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: 0 13px 15px 0px rgb(195 194 196 / 12%), 0 10px 18px 0 rgb(224 220 254 / 15%),
    0 9px 18px 0 rgb(109 101 120 / 6%);
}
.v-sheet.theme--dark.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.v-application .elevation-3 {
  box-shadow: 0 3px 9px -2px rgb(195 194 196 / 12%), 0 3px 4px 0 rgb(224 220 254 / 15%),
    0 1px 8px 0 rgb(109 101 120 / 6%) !important;
}
.v-expansion-panel:before {
  box-shadow: 0 13px 15px 0px rgb(195 194 196 / 12%), 0 10px 18px 0 rgb(224 220 254 / 15%),
    0 9px 18px 0 rgb(109 101 120 / 6%);
}

.v-expansion-panel-header {
  padding: 16px;
}

aside.v-navigation-drawer {
  width: 0px !important;
}
.v-input.expand,
textarea.expand,
.v-select--is-multi {
  height: auto !important;
}
.v-text-field__details,
.v-messages.theme--light {
  display: block !important;
}
.v-input {
  height: 52px;
}
.circle {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  width: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.v-data-table__expand-icon {
  font-size: 18px !important;
}
.v-btn {
  text-transform: none;
}

.v-btn--active.no-active:not(:focus):not(:hover)::before {
  opacity: 0 !important;
}

.v-card__title {
  display: flex !important;
  flex-wrap: nowrap;
  align-items: flex-start;
}

#menu-options .v-list-item__icon {
  margin-right: 14px !important;
}
#menu-options .v-list-group__header__append-icon {
  margin-right: 0px !important;
}

.w100 {
  width: 100%;
}

.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}

.cursor-default {
  cursor: default;
}

@media (max-width: 959px) {
  .sm-max-p-0 {
    padding: 0px !important;
  }
}
</style>
